<template>
  <main class="main chat_report" role="main">
    <div class="main_con">
      <h3>‘{{ storeName }}’ <br />매장을 신고하시겠어요?</h3>
      <div class="report_wrap">
        <div class="report_ttl">
          신고 사유
          <span>(필수)</span>
        </div>
        <div class="report_con">
          <div class="radio" v-for="item in reportTypes" :key="item.value">
            <label
              ><input
                type="radio"
                name="report"
                v-model="form.reportType"
                :value="item.value"
              />
              <span class="option">{{ item.label }}</span></label
            >
          </div>
          <div class="ect_box" v-show="form.reportType === 'ETC'">
            <input
              placeholder="기타 사유를 적어주세요."
              v-model="form.etcReport"
              maxlength="20"
            />
          </div>
        </div>
        <div class="report_ttl">
          신고 내용
          <span>(선택)</span>
        </div>
        <div class="report_con textarea">
          <textarea
            v-model="form.memo"
            placeholder="자세한 신고 사유를 입력해주세요.(200자 이내)"
            maxlength="200"
          />
        </div>
      </div>
    </div>
    <div class="btm_btn">
      <div class="btn_wrap">
        <button class="btn" @click="report">
          신고하기
        </button>
      </div>
    </div>
    <transition name="fade">
      <div
        class="made_toast_layer_common"
        style="bottom:7rem;"
        v-if="isViewToast"
      >
        <div class="toast_msg">{{ errorMessage }}</div>
      </div>
    </transition>
    <DesignPopup2
      :show="designPopup"
      :data="{ type: 'alert', msg: msgPopup }"
      @close="designPopupclose"
    />
  </main>
</template>

<script>
import { mapActions as chatMapActions } from '@common/store/modules/chat';
import * as chatTypes from '@common/store/modules/chat/types';
import DesignPopup2 from '@/common/components/modal/DesignPopup2';
export default {
  name: 'ChatReport',
  description: '채팅방 > 매장신고하기',
  components: {
    DesignPopup2,
  },
  data() {
    return {
      storeName: this.$route.query.name,
      reportTypes: [
        { label: '퍼스지급보장매장 지원금 문제', value: 'IC_SUPPORT_REPORT' },
        { label: '인터넷개통 직거래 유도', value: 'IC_DIRECT_DEAL' },
        { label: '부적절한 언어(욕설/성희롱 등)', value: 'BAD_LANG' },
        { label: '서비스와 관련 없는 광고/홍보', value: 'ADV' },
        { label: '거래 분쟁신고', value: 'TRANSACTION_REPORT' },
        { label: '기타', value: 'ETC' },
      ],
      form: {
        chatRoomId: this.$route.query.id || 0,
        applyId: this.$route.query.applyId || 0,
        reportType: 'IC_SUPPORT_REPORT',
        etcReport: '',
        memo: '',
      },
      isViewToast: false,
      errorMessage: '',
      designPopup: false,
      msgPopup: '',
    };
  },
  methods: {
    ...chatMapActions([chatTypes.REPORT_CHAT]),
    report() {
      if (this.form.reportType === 'ETC') {
        if (this.form.etcReport === '') {
          this.errorMessage = '기타 사유를 적어주세요';
          this.toastView();
          return;
        }
      } else {
        this.form.etcReport = '';
      }
      this[chatTypes.REPORT_CHAT](this.form).then(() => {
        this.designPopup = true;
        this.msgPopup = '신고되었습니다.';
      });
    },
    toastView() {
      this.isViewToast = true;
      setTimeout(() => {
        this.isViewToast = false;
      }, 2000);
    },
    designPopupclose() {
      if (this.form.applyId > 0) {
        this.goApplyMain();
      } else {
        this.$router.go(-1);
      }
    },
    goApplyMain() {
      this.$router.replace({
        name: 'Apply.Main',
      });
    },
  },
};
</script>

<style></style>
